import { VCol } from 'vuetify/lib/components/VGrid';
import { VFooter } from 'vuetify/lib/components/VFooter';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VFooter,{attrs:{"fixed":"","padless":""}},[_c(VCol,{staticClass:"text-center",attrs:{"cols":"12"}},[_vm._v(" "+_vm._s(_vm._f("capitalize")(_vm.appName))+" © "+_vm._s(new Date().getFullYear())+" — "),_c('strong',[_vm._v("Kinetic Technology LTD")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }